import { getLocationQueryToken } from '@/redux/location/selectors';
import { useSelector } from 'react-redux';
import { useSummary } from '@/hooks/useCompany';
import { useValidateCompanyShareToken } from './useValidateCompanyShareToken';
import { useCreateCompanyShareToken } from './useCreateCompanyShareToken';

export const useCompanyShareLink = () => {
  const token = useSelector(getLocationQueryToken) ?? '';
  const summary = useSummary();
  const { isValidShareToken, status, fetchStatus, logo } =
    useValidateCompanyShareToken(
      token,
      summary.status === 'success' ? summary.companyId : undefined
    );
  const { mutate } = useCreateCompanyShareToken();
  return {
    isSharedCompany: isValidShareToken,
    shareCompanyStatus: status,
    shareCompanyFetchStatus: fetchStatus,
    logo,
    createCompanyShareToken: mutate,
    token,
  };
};
